/**
 * Evaluation 결과의 공용 표시 계약.
 *
 * Owns:
 * - 성공률 값과 부재 사유의 사용자 표시 문구.
 * - Evaluation 요청 실패를 화면 문구로 정규화하는 규칙.
 *
 * Does not own:
 * - 실행 상태, 날짜, duration 같은 Evaluation 화면 전용 표시.
 * - API 요청과 컴포넌트 렌더링.
 */
export type SuccessRateAbsence = "pending" | "harvesting" | "unavailable";

/** 성공률이 비었을 때 기다리면 값이 오는 상태인지 판독한다. */
export function successRateAbsence(state: string | null): SuccessRateAbsence {
  if (state === "run_pending") {
    return "pending";
  }
  if (state === "harvesting") {
    return "harvesting";
  }
  return "unavailable";
}

const EMPTY_CELL = "—";

/** 성공률을 단위 없는 백분율 숫자로 표시한다. */
export function formatSuccessRate(successRate: number | null, state: string | null): string {
  if (successRate !== null && Number.isFinite(successRate)) {
    const percent = (successRate * 100).toFixed(1);
    return percent.endsWith(".0") ? percent.slice(0, -2) : percent;
  }
  return successRateEmptyLabel(state);
}

// 부재 문구의 유일한 소유자. 기다리면 값이 오는 상태와 오지 않는 상태를 다른 표기로 구분한다.
export function successRateEmptyLabel(state: string | null): string {
  const absence = successRateAbsence(state);
  if (absence === "pending") {
    return "대기";
  }
  if (absence === "harvesting") {
    return "수집 중";
  }
  return EMPTY_CELL;
}

/** Evaluation 요청 실패 값을 사용자에게 표시할 문구로 정규화한다. */
export function resolveEvalLoadErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message : "요청을 마치지 못했습니다. 다시 시도해 주세요.";
}
